module.exports = __webpack_public_path__ + "static/media/apertum-logo.d0b9c95d.svg";